export enum CustomNavbarIconTypes {
  CERTIFICATION = 'certification',
  SOC_SIM = 'soc-sim',
}
